// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button } from '@/components/ui/core';
import { PasswordInput } from '@/components/ui/inputs';
import { IconLock, IconArrowLeft, IconSettings } from '@tabler/icons-react';
import { AuthLayoutWrapper, PasswordStrength } from '../components';

export default function ChangePasswordPage() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Change password:', { currentPassword, newPassword });
  };

  const passwordsMatch = newPassword === confirmPassword;
  const canSubmit = currentPassword && newPassword.length >= 8 && passwordsMatch;

  return (
    <AuthLayoutWrapper variant="simple">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/demo/auth-pages/other"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to Other Pages
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 56,
                height: 56,
                borderRadius: 14,
                backgroundColor: 'var(--mantine-color-pink-light)',
              }}
            >
              <IconSettings size={28} color="var(--mantine-color-pink-6)" />
            </Center>
            <Title order={2} ta="center">Change password</Title>
            <Text c="dimmed" size="sm" ta="center" maw={300}>
              Update your password to keep your account secure.
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <PasswordInput
              label="Current password"
              placeholder="Enter current password"
              leftSection={<IconLock size={16} />}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
            />

            <div>
              <PasswordInput
                label="New password"
                placeholder="Enter new password"
                leftSection={<IconLock size={16} />}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              {newPassword && <PasswordStrength password={newPassword} variant="bar" />}
            </div>

            <PasswordInput
              label="Confirm new password"
              placeholder="Confirm new password"
              leftSection={<IconLock size={16} />}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              error={confirmPassword && !passwordsMatch ? "Passwords don't match" : undefined}
            />

            <Button type="submit" fullWidth color="pink" disabled={!canSubmit}>
              Update password
            </Button>
          </Stack>
        </form>
      </Stack>
    </AuthLayoutWrapper>
  );
}
